import axios from 'axios';

const API_URL = 'https://api.workloob.com/api';
// const API_URL = 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    REGISTER_EMAIL: '/auth/register-email',
    REGISTER_WALLET: '/auth/register-wallet',
    ME: '/auth/me',
  },
  BLOGS: {
    LIST: '/blogs',
    DETAIL: (id) => `/blogs/${id}`,
    CREATE: '/blogs',
    UPDATE: (id) => `/blogs/${id}`,
    DELETE: (id) => `/blogs/${id}`,
    LIKE: (id) => `/blogs/${id}/like`,
    SAVE: (id) => `/blogs/${id}/save`,
    COMMENT: (id) => `/blogs/${id}/comment`,
    COMMENT_LIKE: (id, commentId) => `/blogs/${id}/comment/${commentId}/like`,
    VIEW: (id) => `/blogs/${id}/view`,
    IMPRESSION: (id) => `/blogs/${id}/impression`,
    MY_BLOGS: '/blogs/user/my-blogs',
    EARNINGS: '/blogs/user/earnings',
    WITHDRAW: '/blogs/user/withdraw',
    STATS: '/blogs/user/stats',
    FOLLOW: (userId) => `/blogs/user/follow/${userId}`,
    SAVED: '/blogs/user/saved',
    FOLLOWING: '/blogs/user/following',
    ADMIN_ALL: '/blogs/admin/all',
    ADMIN_FEATURE: (id) => `/blogs/admin/${id}/feature`,
    ADMIN_SPONSOR: (id) => `/blogs/admin/${id}/sponsor`,
    ADMIN_PRIORITY: (id) => `/blogs/admin/${id}/priority`,
    ADMIN_DELETE: (id) => `/blogs/admin/${id}`,
  },
  NOTIFICATIONS: {
    LIST: '/notifications',
    UNREAD_COUNT: '/notifications/unread-count',
    MARK_READ: (id) => `/notifications/${id}/read`,
    MARK_ALL_READ: '/notifications/read-all',
  },
  EMAIL_SUBSCRIPTIONS: {
    SUBSCRIBE: '/email-subscriptions',
    LIST: '/email-subscriptions',
    DELETE: (id) => `/email-subscriptions/${id}`,
    DELETE_MULTIPLE: '/email-subscriptions',
    EXPORT: '/email-subscriptions/export',
  },
};

export const CATEGORIES = [
  'Recruiting',
  'News',
  'Sport',
  'Business',
  'Innovation',
  'Health',
  'Culture',
  'Arts',
  'Travel',
  'Earth',
  'Technology',
  'Education',
  'Entertainment',
];
